/* Copyright 2013 - 2022 Waiterio LLC */
/** @jsx jsx */
import React, { useState } from 'react'
import { jsx, css } from '@emotion/core'
import addImage from '@waiterio/images-client/addImage.js'
import readFile from '@waiterio/shared/readFile.js'

const fieldInput = css`
  label: fieldInput;

  width: 100%;
  box-shadow: inset 0px 0px 0px 1px #d8e0ed;
  border-radius: 4px;
  padding: 12px;
  color: #6a768a;
  line-height: 24px;

  ::placeholder {
    // TODO color
  }

  @media (hover: hover) {
    &:not(.disabled):hover {
      box-shadow: inset 0px 0px 0px 2px var(--color-primary-lightest);
      cursor: text;
    }
  }

  &:not(.disabled):active {
    box-shadow: inset 0px 0px 0px 2px var(--color-primary-lightest);
    cursor: text;
  }
`

const fieldLabel = css`
  font-size: 14px;
  font-weight: bold;
  text-transform: capitalize;
  color: #273854;
  line-height: 48px;
`

const UploadPage = props => {
  const [error, setError] = useState(false)
  const [name, setName] = useState()
  const [sizes, setSizes] = useState('1920, 1600, 1366, 1024, 768, 640')
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState(false)

  function changeName(event) {
    setName(event.target.value)
  }

  const onChangeSizes = event => {
    let sizes = event.target.value
    setSizes(sizes)
  }

  async function uploadPhoto(event) {
    const file = event.target.files[0]
    let extension

    if (file.name && file.name.indexOf('.' > -1)) {
      const splits = file.name.split('.')
      extension = splits[splits.length - 1]
    } else if (file.type && file.type.indexOf('/') > -1) {
      const splits = file.type.split('/')
      extension = splits[splits.length - 1]
    }

    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      readFile(file)
        .then(file => {
          const formats = ['jpg', 'webp']
          const sizesInInt = sizes.split(',').map(Number)

          let variants = []

          for (let f = 0; f < formats.length; f += 1) {
            let format = formats[f]
            for (let s = 0; s < sizesInInt.length; s += 1) {
              let size = sizesInInt[s]
              variants.push({
                format,
                size,
              })
            }
          }

          setLoading(true)

          return addImage({
            name,
            file,
            variants,
          })
        })
        .then(response => {
          console.log('response', response)

          setLoading(false)
          setResponse(response)
        })
        .catch(error => {
          setError(error)
        })
    } else {
      setError('Images should be in .jpg or .png format')
    }
  }

  return (
    <div css={{ background: 'white' }}>
      {error && <div>{error}</div>}
      {loading && <div>loading</div>}
      {response && (
        <div css={{ display: 'flex', flexDirection: 'column' }}>
          <div>{response.url}</div>
          {response.variants?.map(variant => (
            <div key={variant}>{variant}</div>
          ))}
        </div>
      )}
      {!loading && !response && (
        <div css={{ padding: 16, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', margin: 'auto', maxWidth: 480 }}>

          <h1 css={{ marginTop: 1 }}>Upload Image</h1>

          <div css={{ margin: 'auto' }}>
            <div>
              <label htmlFor="name" css={fieldLabel}>Name</label>
              <input
                id="name"
                css={fieldInput}
                onChange={changeName}
                placeholder="food-truck-cover"
                value={name || ''}
              />
            </div>

            <div css={{ marginTop: 32 }}>
              <label htmlFor="sizes" css={fieldLabel}>Sizes</label>
              <input
                id="sizes"
                css={fieldInput}
                onChange={onChangeSizes}
                placeholder="sizes ex: 576, 320, 240, 120"
                value={sizes}
              />
            </div>

            <div css={{ marginTop: 32 }}>
              <input
                id="uploadPhoto"
                type="file"
                accept="image/*"
                capture
                onChange={uploadPhoto}
              />
            </div>

          </div>

        </div>
      )}
    </div>
  )
}

export default UploadPage
